<template>
  <div>
    <drawer ref="drawer"></drawer>
    <v-app-bar app color="#fff" dark>
      <v-app-bar-nav-icon
        light
        class="ml-1"
        color="#7D9B38"
        aria-hidden="true"
        @click="$refs.drawer.isOpen = !$refs.drawer.isOpen"
      ></v-app-bar-nav-icon>
      <v-divider
        class="mx-4"
        style="border-color: #666666"
        vertical
      ></v-divider>
      <img src="/images/logo_hds_3.svg" height="50px" />

      <v-spacer></v-spacer>
      <v-btn
        v-if="$route.name != 'report'"
        light
        text
        small
        class="hidden-sm-and-down"
        color="#7D9B38"
        href="javascript:history.go(-1)"
        >Zurück</v-btn
      >
    </v-app-bar>
    <div style="z-index: 1">
      <v-speed-dial
        v-model="fab"
        fab
        dark
        fixed
        bottom
        right
        color="primary"
        transition="slide-y-reverse-transition"
      >
        <template v-slot:activator>
          <v-btn v-model="fab" color="accent" dark fab>
            <v-icon v-if="fab">mdi-close</v-icon>
            <v-icon v-else>mdi-share-variant</v-icon>
          </v-btn>
        </template>
        <v-btn
          fab
          dark
          small
          color="#999"
          href="mailto:email@example.com?&subject=Digital-Report 2020: Non-Profits und IT&body=Einblicke in die Digitalisierung von Non-Profits in der aktuell größten Studie: www.digital-report.org"
          target="blank"
        >
          <v-icon>mdi-email</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          small
          color="#999"
          href="https://www.facebook.com/sharer/sharer.php?u=www.digital-report.org"
          target="blank"
        >
          <v-icon>mdi-facebook</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          small
          color="#999"
          href="https://twitter.com/intent/tweet?text=Herausforderungen%20Digitalisierung%20im%20Non-Profit-Sektor&url=www.digital-report.org%2Freport%23herausforderungenUebersicht&hashtags=digitalreport,%20hds&via=Stifter-helfen"
          target="blank"
        >
          <v-icon>mdi-twitter</v-icon>
        </v-btn>
      </v-speed-dial>
    </div>
  </div>
</template>

<script>
import Drawer from "@/components/layout/Drawer.vue";

export default {
  name: "Navigation",
  components: {
    Drawer
  },
  data: () => ({
    fab: false,
    tabs: null
  })
};
</script>
